import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LoadingOverlayService } from '../../../core/services/loading-overlay.service';

const AUTODROMO_LOGO_URL = 'https://munily-public-cdn.s3.us-east-1.amazonaws.com/faceRecognition/customized/Autodromo/autodromoLetterLogo.svg';

@Component({
  selector: 'app-loading-overlay',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading-overlay.component.html',
  styleUrl: './loading-overlay.component.scss'
})
export class LoadingOverlayComponent {
  protected readonly loadingOverlay = inject(LoadingOverlayService);
  protected readonly logoUrl = AUTODROMO_LOGO_URL;
}
